import * as moment from 'moment';
import { Moment } from 'moment';
import { Attachment, IAttachment } from '../../../components/attachment-upload-btn/attachment';

export interface IDiplomaItem {
  attachment?: IAttachment[];
  country?: string;
  date_of_expiry?: Moment;
  date_of_issue?: Moment;
  number?: string;
}

export class DiplomaItem implements IDiplomaItem {
  attachment?: Attachment[];
  country?: string;
  date_of_expiry?: Moment;
  date_of_issue?: Moment;
  number?: string;

  constructor( item: IDiplomaItem = {} ) {
    this.attachment = this.transformAttachmets(item.attachment);
    this.country = item.country;
    this.date_of_expiry = item.date_of_expiry ? moment(item.date_of_expiry) : null;
    this.date_of_issue = item.date_of_issue ? moment(item.date_of_issue) : null;
    this.number = item.number;
  }

  private transformAttachmets( data: IAttachment[] = [] ): Attachment[] {
    return data
      .filter(( item ) => typeof item === 'object')
      .map(( attachment ) => new Attachment(attachment));
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/diploma-item.ts